<template>
  <v-container fluid class="fill-height">
    <k-nodata-info>
      <template v-slot:icon>
        <i class="fas fa-exclamation"></i>
      </template>
      <template v-slot:title>
        {{ nyelvesites['oldal_nem_beagyazhato_text'] }}
      </template>
    </k-nodata-info>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { AppStoreTypes } from '../store/modules/app';
export default {
  name: 'private-site',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({
      user: AppStoreTypes.user.get,
    }),
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {},
};
</script>
ű
